import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { Trans } from '@lingui/react';
import Isvg from 'react-inlinesvg';
import closeSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_cross.svg';
import tickSvg from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_tick.svg';
import '../../styles/core.scss';
import css from './confirmation-button.scss';

const ConfirmationButton = ({ onConfirm, onCancel, display = false }) => (
    <div className={display ? css['confirmation-button-holder'] : css.none}>
        <div><Trans>Are you sure you would like to remove/unassign all students?</Trans></div>
        <div className={css.btn}>
            <button
                onClick={() => { onCancel(); }}
                className={`btn ${css.cancel}`}
            ><Isvg src={closeSvg} cacheGetRequests={false} />
            </button>
            <button
                onClick={() => { onConfirm(); }}
                className={`btn ${css.ok}`}
            ><Isvg src={tickSvg} cacheGetRequests={false} />
            </button>
        </div>
    </div>);

ConfirmationButton.propTypes = {
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    display: PropTypes.bool
};

export default styleable(css)(ConfirmationButton);



// WEBPACK FOOTER //
// ./components/confirmation-button/confirmation-button.js